<template>
  <div class="cabinet-shortcut-buttons">
    <DxButton icon="upload" styling-mode="text" @click="upload"/>
    <DxButton icon="preferences" styling-mode="text" @click="settings"/>
  </div>
</template>

<script setup>
  import { useRouter } from 'vue-router'
  import DxButton from "devextreme-vue/button";

  const props = defineProps(['cabinetId'])
  const router = useRouter()

  const upload = () => router.push({ name: 'cabinetUpload', params: { cabinetId: props.cabinetId } })
  const settings = () => router.push({ name: 'cabinetSettings', params: { cabinetId: props.cabinetId } })
</script>

<style scoped lang="scss">
  .cabinet-shortcut-buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 0.625rem;
    padding: 0 1.25rem;
  }

  .disabled {
    color: lightgray;
  }
</style>
